import { Route, Routes } from "react-router-dom";
import { AssetExceptionsWrapper } from "~/components/asset-exceptions-wrapper";
import { OverviewTab } from "~/components/asset-overview-tab";
import { Space } from "~/lib/types";
import { AssetPage } from "~/pages/inventory/asset";
import { AssetDataQueries } from "~/pages/inventory/data-queries";
import { AssetPoliciesTab } from "~/pages/inventory/asset/asset-policies-tab";
import { AssetSoftwareTab } from "~/pages/inventory/components/AssetSoftware";
import { SpaceOrWorkspaceScope } from "~/hooks/useScope";
import { FindingOnAsset } from "~/pages/findings/FindingOnAsset/FindingOnAsset";
import { PageLayout } from "~/routes/page-layout";
import { AssetFindingsTab } from "~/pages/inventory/asset/AssetFindingsTab";
import { LegacyRedirect } from "~/routes/LegacyRouteRedirect";

export function AssetRoutes({
  space,
  scope,
}: {
  space: Space;
  scope: SpaceOrWorkspaceScope;
}) {
  return (
    <Routes>
      <Route element={<PageLayout />}>
        <Route path="/:id" element={<AssetPage space={space} scope={scope} />}>
          <Route index element={<OverviewTab />} />
          <Route path="overview" element={<OverviewTab />} />
          <Route path="policies" element={<AssetPoliciesTab />} />
          <Route path="findings" element={<AssetFindingsTab />} />
          <Route path="data-queries" element={<AssetDataQueries />} />
          <Route path="software" element={<AssetSoftwareTab />} />
          <Route path="exceptions" element={<AssetExceptionsWrapper />} />
        </Route>
      </Route>
      <Route path="/:id/vulnerabilities/:vulnId" element={<FindingOnAsset />} />
      <Route path="/:id/advisories/:advisoryId" element={<FindingOnAsset />} />
      <Route path="/:id/check" element={<FindingOnAsset />} />
      <Route path="/:id/generic-finding" element={<FindingOnAsset />} />

      {/* Redirect legacy list routes to findings with type filter for backwards compatibility */}
      <Route
        path="/:id/advisories"
        element={<LegacyRedirect from="advisories" type="ADVISORY" />}
      />
      <Route
        path="/:id/vulnerabilities"
        element={<LegacyRedirect from="vulnerabilities" type="CVE" />}
      />
      <Route
        path="/:id/checks"
        element={<LegacyRedirect from="checks" type="CHECK" />}
      />
    </Routes>
  );
}
